import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function CssfPdfHeader( { resumeData } ) {

    const { logoSrc } = extractResumeProperties( resumeData );

    const styles = StyleSheet.create( {
        headerCssf: {
            width: 50,
            alignSelf: 'flex-start',
            position: 'absolute',
            top: 40,
            left: 40,
        },
        section: {
            flexDirection: 'row',
            marginBottom: 10,
            fontSize: 10,
        },
        leftColumn: {
            width: '30%',
        },
        rightColumn: {
            width: '700%',
            marginLeft: 12,
        },
        textStart: {
            textAlign: 'start',
        },
    } );

    return (
        <View style={ styles.headerCssf } fixed>
            <View style={ [ styles.section, { marginBottom: 0 } ] }>
                <View style={ [ styles.leftColumn, { width: "30%", justifyContent: "flex-start" } ] }>
                    <Image style={ { width: 80, height: 60, objectFit: "contain" } } src={ logoSrc }/>
                </View>
                <View style={ [ styles.rightColumn, { width: "70%" } ] }>
                    <Text style={ [
                        styles.textStart,
                        {
                            fontFamily: "Verdana, sans-serif",
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginTop: 30,
                            color: "#009999",
                            marginLeft: 138,
                            width: "350px",
                            maxWidth: "350px"
                        } ] }>
                        CURRICULUM VITAE
                    </Text>
                </View>
            </View>
        </View>
    );
}
